import { render, staticRenderFns } from "./WhrjHeader.vue?vue&type=template&id=448f8dc2&scoped=true&"
import script from "./WhrjHeader.vue?vue&type=script&lang=js&"
export * from "./WhrjHeader.vue?vue&type=script&lang=js&"
import style0 from "./WhrjHeader.vue?vue&type=style&index=0&id=448f8dc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f8dc2",
  null
  
)

export default component.exports